import React, {Component} from 'react';
import {connect} from "react-redux";
import AsyncSelect from "react-select/async";
import apiUser from "../../../apiUser";
import PropTypes from "prop-types";
import {isNull} from "lodash";
import VehicleAddModal from "../VehicleAddModal/VehicleAddModal";
import CreatableSelect from "react-select/async-creatable/dist/react-select.esm";
import apiPlatform from "../../../apiPlatform";
import {Badge} from "reactstrap";
import parseObjectToUrlParams from "../../../utils/parseObjectToUrlParams";
import {withTranslation} from "react-i18next";
import workerHasPrivilege from "../../../utils/workerHasPrivilege";

class VehicleSelect extends Component {

  constructor(props) {
    super(props);

    this.selectRef = React.createRef();

    this.state = {
      focused: false,
      searchTimeout: false,
      defaultOptions: [],
      defaultValues: [],
      modalAdd: false,
      loading: false,
      search: '',
      options: [],
      value: props.value && this.getValueName(props.value),
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if(this.props.vehicle){
      this.setVehicle(this.props.vehicle);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.vehicle && this.props.vehicle !== prevProps.vehicle){
      this.setVehicle(this.props.vehicle);
    }
    if(this.props.value !== prevProps.value){
      this.setState({
        value: this.props.value ? this.getValueName(this.props.value) : null,
      })
    }
    if(this.props.currentOwner !== prevProps.currentOwner || this.props.currentOwnerSort !== prevProps.currentOwnerSort){
      this.setState({
        defaultOptions: [],
      })
    }
  }

  getValueName = value => ({
    label: <i className="text-info">{value}</i>,
    value: value,
  })

  setVehicle = (vehicleId) => {
    if(!workerHasPrivilege('vehicles.view')){
      return
    }
    apiUser.vehicles.get(vehicleId)
    .then(vehicle => {
      this.setState({
        value: {
          value: this.props.vehicle,
          label: this.getVehicleLabelSelected(vehicle)
        }
      })
    });
  }

  handleOnFocus = () => {
    this.setState({
      focused: true,
      search: !this.props.vehicle ? this.state.value?.value : '',
    })
    if(this.state.defaultOptions.length === 0){
      this.fetchData(
        '',
        options => this.setState({defaultOptions: options}),
        vehicles => this.setState({defaultValues: vehicles})
      )
    }
  }

  fetchData(search, callback, handlerData){
    this.setState({
      loading: true,
    })
    clearTimeout(this.state.searchTimeout);
    this.setState({
      searchTimeout: setTimeout(() => {
        let params = {
          'order[id]': 'desc',
          q: search,
        }

        if(this.props.currentOwner && !search){
          params.currentOwner = this.props.currentOwner
        }
        if(this.props.currentOwnerSort){
          params.currentOwnerSort = this.props.currentOwner
        }

        apiPlatform.vehicles.list(parseObjectToUrlParams(params))
        .then(res => {
          let options = res.data['hydra:member'].map(vehicle => {
            return {
              value: vehicle.id,
              label: this.getVehicleLabel(vehicle),
            }
          });

          if(this.props.allowCreate){
            options.unshift({
              value: null,
              label: (
                <div className="d-flex justify-content-center align-items-center mb-0 text-primary py-1">
                  <i className="fas fa-car fa-2x" />
                  <span className="ml-2">{this.props.t('btn_create')}</span>
                </div>
              )
            })
          }

          this.setState({
            data: res.data['hydra:member'],
            loading: false,
          }, () => {
            callback(options);
            handlerData && handlerData(res.data['hydra:member']);
          });
        }).catch(() => {
          this.setState({
            loading: false,
          })
        })
      }, 450)
    })
  }

  getVehicleLabel(vehicle){
    return <div className="d-flex align-items-center">
      <i className="fas fa-car mr-2" />

      <div className="d-flex flex-column">
        <span>{vehicle.brand} {vehicle.model} {vehicle.productionDate} {vehicle.capacity && <span>{vehicle.capacity} <span>cm<sup>3</sup></span></span>}</span>
        <div className="d-flex">
          {vehicle.registrationNumber && <span className="mr-2">{vehicle.registrationNumber}</span>}
          {vehicle.vin && <span className="mr-2">{vehicle.vin}</span>}
          {vehicle.color && <span className="mr-2">{vehicle.color}</span>}
        </div>
      </div>
    </div>;
  }

  getVehicleLabelSelected(vehicle){
    return <div className="d-flex flex-row align-items-center">
      <i className="fas fa-car mr-2" />
      <div className="d-flex flex-row flex-grow-1 justify-content-between">
        <span>{vehicle.brand} {vehicle.model} {vehicle.productionDate}</span>
        <span className="mr-2">{vehicle.registrationNumber}</span>
      </div>
    </div>;
  }

  handleInputChange(search){
    this.setState({ search });
    return search;
  }

  render() {
    const {value, data, modalAdd, defaultOptions, defaultValues, loading} = this.state;

    let styles = {};
    if(this.props.documentAsTarget){
      styles.menu = (menu) => ({
        ...menu,
        maxWidth: '95vw',
        width: '250px',
      })
      styles.menuPortal = base => ({
        ...base,
        zIndex: 9999,
      });
    }

    let SelectComponent = AsyncSelect;
    let defaultProps = {
      classNamePrefix: "react-select",
      styles,
      menuPortalTarget: this.props.documentAsTarget ? document.body : undefined,
      isLoading: loading,
      defaultOptions: defaultOptions,
      ref: this.selectRef,
      autoFocus: this.props.autoFocus,
      className: this.props.className,
      onBlur: e => {
        this.props.onBlur && this.props.onBlur(e);
        this.setState({
          focused: false,
        })
      },
      onFocus: this.handleOnFocus,
      isClearable: true,
      isDisabled: (!workerHasPrivilege('vehicles.view')) ? true : this.props.isDisabled,
      placeholder: this.props.placeholder ?? this.props.t('placeholder'),
      loadingMessage: () => <span>{this.props.t('common:search_in_progress')} <i className="fas fa-spin fa-spinner ml-2" /></span>,
      noOptionsMessage: () => <span><i className="fa fa-car" /> <span className="ml-2">{this.props.t('no_options')}</span></span>,
      loadOptions: this.fetchData,
      onInputChange: this.handleInputChange,
      value,
      inputValue: this.state.focused ? this.state.search : undefined,
      onChange: option => {
        if(isNull(option)){
          this.setState({
            value: null
          });

          this.props.onChange(null);
        }else if(isNull(option.value)){
          this.setState({
            value: null,
            modalAdd: true,
          });
        }else{
          const vehicle = data.find(c => c.id === option.value) ?? defaultValues.find(c => c.id === option.value);

          if(vehicle){
            this.setState({
              value: {
                value: vehicle.id,
                label: this.getVehicleLabelSelected(vehicle),
              }
            });

            this.props.onChange(vehicle);
          }else{
            if(!this.props.requireVehicle){
              this.setState({
                value: this.getValueName(option.value)
              });

              this.props.onChange(option.value);
            }
          }
        }
      }
    }

    if(!this.props.requireVehicle){
      SelectComponent = CreatableSelect;

      defaultProps.createOptionPosition = 'first';
      defaultProps.formatCreateLabel = (value) => <div className="text-center"><Badge color="info"><i>{value}</i></Badge></div>;
    }

    return <React.Fragment>
      <SelectComponent
        {...defaultProps}
      />
      {modalAdd && <VehicleAddModal
        onModalClose={() => this.setState({modalAdd: false})}
        onAdded={vehicle => {
          this.setState({
            modalAdd: false,
            value: {
              value: vehicle.id,
              label: this.getVehicleLabelSelected(vehicle),
            }
          });
          this.props.onChange(vehicle);
        }}
      />}
    </React.Fragment>
  }
}

VehicleSelect.defaultProps = {
  documentAsTarget: false,
  autoFocus: false,
  className: '',
  requireVehicle: true,
  allowCreate: true,
};

VehicleSelect.propTypes = {
  allowCreate: PropTypes.bool,
  documentAsTarget: PropTypes.bool,
  currentOwner: PropTypes.number,
  currentOwnerSort: PropTypes.number,
  autoFocus: PropTypes.bool,
  requireVehicle: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  vehicle: PropTypes.number,
  className: PropTypes.string,
};

export default connect(null, null, null , {forwardRef: true})(withTranslation('vehicle_select', {withRef: true})(VehicleSelect));
